import { QAlert } from "./QAlert";

export class QGoogleAlert extends QAlert {
  constructor() {
    super();
  }

  ExecuteCustomCommand(aCmd) {
    var panelHandled = true;
    var cmdCode = aCmd.GetCmdCode();
    switch (cmdCode) {
      case "OKLaunchDrive":
        window.open("https://drive.google.com/");
        break;
      default:
        panelHandled = false;
        break;
    }
    return panelHandled;
  }
}
